import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Modal } from "react-bootstrap";
import styles from "./AdharRegistrartion.module.scss";
import MobileVerification from "./MobileVerfication";
import { BsCreditCard2Front } from "react-icons/bs";
import { GiHealthNormal } from "react-icons/gi";
import { MdPhoneIphone } from "react-icons/md";
import AadharVerification from "./AadharVerification";
import AbhaVerification from "./AbhaVerification";

const Verification = ({
  onBack,
  clinicId,
  clinicName,
  setModalVisible,
  setShowRegistrationModal,
  setShowMobileRegistration,
  setAadharNumber,
  setShowAdharRegistration,
  loading
}) => {
  const [verificationType, setVerificationType] = useState(null);
  const handleVerificationClick = (verificationType) => {
    setVerificationType(verificationType);
  };

  const renderVerificationComponent = () => {
    switch (verificationType) {
      case "Mobile":
        return (
          <MobileVerification
            clinicId={clinicId}
            setModalVisible={setModalVisible}
            setShowRegistrationModal={setShowRegistrationModal}
            setAadharNumber={setAadharNumber}
            loading={loading}
          />
        );
      case "Aadhar":
        return (
          <AadharVerification
            clinicId={clinicId}
            clinicName={clinicName}
            setAadharNumber={setAadharNumber}
            setShowRegistrationModal={setShowRegistrationModal}
            setShowAdharRegistration={setShowAdharRegistration}
            setModalVisible={setModalVisible}
            loading={loading}
          />
        );
      case "ABHA":
        return (
          <AbhaVerification
            clinicId={clinicId}
            setModalVisible={setModalVisible}
            setShowRegistrationModal={setShowRegistrationModal}
            setAadharNumber={setAadharNumber}
            setShowAdharRegistration={setShowAdharRegistration}
            loading={loading}
          />
        );
    }
  };

  return (
    <>
      {verificationType === null && (
        <Row>
          <Col md={4}>
            <div
              onClick={() => handleVerificationClick("Aadhar")}
              className={styles.verificationCard}
            >
              <BsCreditCard2Front
                className={styles.verificationIcon}
                size={50}
              />
              <h5 className={styles.verificationTitle}>
                Aadhar{" "}
                <span className={styles.verificationSubtitle}>
                  Verification
                </span>
              </h5>
            </div>
          </Col>
          <Col md={4}>
            <div
              onClick={() => handleVerificationClick("Mobile")}
              className={styles.verificationCard}
            >
              <MdPhoneIphone className={styles.verificationIcon} size={50} />
              <h5 className={styles.verificationTitle}>
                Mobile{" "}
                <span className={styles.verificationSubtitle}>
                  Verification
                </span>
              </h5>
            </div>
          </Col>
          <Col md={4}>
            <div
              onClick={() => handleVerificationClick("ABHA")}
              className={styles.verificationCard}
            >
              <GiHealthNormal className={styles.verificationIcon} size={50} />
              <h5 className={styles.verificationTitle}>
                ABHA{" "}
                <span className={styles.verificationSubtitle}>
                  Verification
                </span>
              </h5>
            </div>
          </Col>
        </Row>
      )}

      {verificationType !== null && (
        <div className={styles.verificationContainer}>
          {renderVerificationComponent()}
        </div>
      )}
    </>
  );
};

export default Verification;
